
export const getEmailType = (name: string) => {

  switch (name) {

    case 'emailChannelSubscription':
        return 'user_channel_subscribe'
    case 'emailCommRegistrationConfirmation':
        return 'user_webcast_register'
    case 'emailComm24hrReminder':
        return 'communication_reminder_24hr_registrants'
    case 'emailCommStartingNow':
      return 'communication_reminder_starting_now_registrants'
    case 'emailCommMissedYou':
      return 'communication_missed_you'
    case 'emailCommViewerFollowup':
      return 'communication_viewer_followup'
    case 'emailCommRerun':
      return 'communication_rerun'
    case 'emailCommRescheduled':
      return 'communication_rescheduled'
    case 'emailCommCancelled':
      return 'communication_cancelled' 
    case 'emailEventRegistrationConfirmation':
      return 'user_virtual_event_register'
    default:
        return name

  }

}
